import posthog from 'posthog-js';
import { isOptedOut } from './consent';

export const initPostHog = () => {
  if (typeof window === 'undefined') return;

  posthog.init('phc_GUcspph5dRWuS3dOSph2AOZgMMjl5KudKw0F28gTGol', {
    api_host: 'https://us.i.posthog.com',
    person_profiles: 'identified_only',
    capture_pageview: true,
    capture_pageleave: true,
    autocapture: true,
  });

  // Respect existing opt-out preference
  if (isOptedOut()) {
    posthog.opt_out_capturing();
  }
};

export function enableAnalytics(): void {
  posthog.opt_in_capturing();
}

export function disableAnalytics(): void {
  posthog.opt_out_capturing();
}

export { posthog };
